export default __webpack_public_path__ + "static/media/homebuyer.e9b47bfa.png";